import { useEffect, useState } from "react";
import { 
    Button, Col, Empty, Form, Input, Modal, Pagination, Popconfirm, 
    Row, Select, Space, Table, Tooltip, notification 
} from "antd";
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { 
    getTemplatePrivacyPreferences, putTemplatePrivacyPreferences,
    deleteTemplatePrivacyPreferences, deleteTemplatePrivacyPreferenceById,
} from "@axios/api.device";

import { useTranslation } from "react-i18next";

interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

const defaultAuthOptions = [
    {label: "Allow", value: "Allow"},
    {label: "Deny", value: "Deny"},
    {label: "AllowStandardUserToSetSystemService", value: "AllowStandardUserToSetSystemService"},
]

const defaultKeyOptions = [
    {label: "Accessibility", value: "Accessibility", rules: ["Allow", "Deny"]},
    {label: "AddressBook", value: "AddressBook", rules: ["Allow", "Deny"]},
    // {label: "AppleEvents", value: "AppleEvents", rules: ["Allow", "Deny"]},
    {label: "BluetoothAlways", value: "BluetoothAlways", rules: ["Allow", "Deny"]},
    {label: "Calendar", value: "Calendar", rules: ["Allow", "Deny"]},
    {label: "Camera", value: "Camera", rules: ["Deny"]},
    {label: "FileProviderPresence", value: "FileProviderPresence", rules: ["Allow", "Deny"]},
    {label: "ListenEvent", value: "ListenEvent", rules: ["Deny","AllowStandardUserToSetSystemService"]},
    {label: "MediaLibrary", value: "MediaLibrary", rules: ["Allow", "Deny"]},
    {label: "Microphone", value: "Microphone", rules: ["Deny"]},
    {label: "Photos", value: "Photos", rules: ["Allow", "Deny"]},
    {label: "PostEvent", value: "PostEvent", rules: ["Allow", "Deny"]},
    {label: "Reminders", value: "Reminders", rules: ["Allow", "Deny"]},
    {label: "ScreenCapture", value: "ScreenCapture", rules: ["Deny","AllowStandardUserToSetSystemService"]},
    {label: "SpeechRecognition", value: "SpeechRecognition", rules: ["Allow", "Deny"]},
    {label: "SystemPolicyAllFiles", value: "SystemPolicyAllFiles", rules: ["Allow", "Deny"]},
    {label: "SystemPolicyAppBundles", value: "SystemPolicyAppBundles", rules: ["Allow", "Deny"]},
    {label: "SystemPolicyAppData", value: "SystemPolicyAppData", rules: ["Allow", "Deny"]},
    {label: "SystemPolicyDesktopFolder", value: "SystemPolicyDesktopFolder", rules: ["Allow", "Deny"]},
    {label: "SystemPolicyDocumentsFolder", value: "SystemPolicyDocumentsFolder", rules: ["Allow", "Deny"]},
    {label: "SystemPolicyDownloadsFolder", value: "SystemPolicyDownloadsFolder", rules: ["Allow", "Deny"]},
    {label: "SystemPolicyNetworkVolumes", value: "SystemPolicyNetworkVolumes", rules: ["Allow", "Deny"]},
    {label: "SystemPolicyRemovableVolumes", value: "SystemPolicyRemovableVolumes", rules: ["Allow", "Deny"]},
    {label: "SystemPolicySysAdminFiles", value: "SystemPolicySysAdminFiles", rules: ["Allow", "Deny"]},
]

const authMappingKey: any = {
    Allow: defaultKeyOptions.filter((item) => item.rules.includes("Allow")),
    Deny: defaultKeyOptions.filter((item) => item.rules.includes("Deny")),
    AllowStandardUserToSetSystemService: defaultKeyOptions.filter((item) => item.rules.includes("AllowStandardUserToSetSystemService")),
    "": defaultKeyOptions
}

export const TemplatePrivacyPreferences = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [tableList, setTableList] = useState<any[]>([]);
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(20);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [placeholder, setPlaceholder] = useState<string>("");
    const [id, setId] = useState<string>("");
    const [authOptionsList, setAuthOptionsList] = useState<any[]>([]);
    const [keyOptionsList, setKeyOptionsList] = useState<any[]>([]);
    const [dataForm] = Form.useForm();

    

    const { t } = useTranslation();

    useEffect(() => { getDataList() }, [])

    const getDataList = (index=pageIndex, size=pageSize) => {
        getTemplatePrivacyPreferences(templateId, {pageIndex: index, pageSize: size}).then((res) => {
            const {dataList, pageIndex, pageSize, totalCount} = res;
            if (res && dataList.length) {
                setTableList(dataList);
                setPageIndex(pageIndex);
                setPageSize(pageSize);
                setTotalCount(totalCount);
                setShowTable(2);
                updateTemplate();
            } else {
                setTableList([]);
                setShowTable(1);
            }
        })
        
    }

    const onOk = () => {
        dataForm.validateFields().then(res => {
            var tmpKeys: any = [];
            res.ruleList = res.ruleList.filter((rule: any) => {
                var tmp = rule.key && rule.authorization;
                if (tmp && !tmpKeys.includes(rule.key)) {
                    tmpKeys.push(rule.key);
                    return tmp;
                } else {
                    return false;
                }
            });
            //res.staticCode = res.staticCode === "0" ? false : true;
            putTemplatePrivacyPreferences(templateId, {id, ...res}).then(() => {
                notification.success({message: t("操作成功")});
                setShowModal(false);
                setAuthOptionsList([]);
                setKeyOptionsList([]);
                setId("");
                dataForm.resetFields();
                updateTemplate();
                getDataList();
            })
        })
    }

    const onEdit = (row: any) => {
        for (let index = 0; index < row.ruleList.length; index++) {
            addOptionsList(row.ruleList[index], index);
        }
        setId(row.id);
        // row.staticCode = row.staticCode ? "1" : "0";
        dataForm.setFieldsValue(row);
        setShowModal(true);
        console.log(row);
    }

    const deleteById = (id: string) => {
        setLoading(true);
        deleteTemplatePrivacyPreferenceById(templateId, id).then(() => {
            if (tableList.length === 1) {
                setTableList([]);
            }
            notification.success({message: t("删除成功")});
            setLoading(false);
            updateTemplate();
            getDataList();
        })
    }

    const deleteAll = () => {
        deleteTemplatePrivacyPreferences(templateId).then(() => {
            notification.success({message: t("删除成功")});
            setTableList([]);
            updateTemplate();
            getDataList();
        })
    }

    const placeholderChange = (value: any) => {
        if (value === "path") {
            setPlaceholder(`${t("如")}: /Application/Apple Configurator2.app`)
        } else {
            setPlaceholder(`${t("如")}: com.apple.screensharing.agent`)
        }
    }

    const authChange = (value: any, index: number) => {
        keyOptionsList[index] = authMappingKey[value ? value : ""];
        setKeyOptionsList([...keyOptionsList]);
        
    }

    const keyChange = (value: any, index: number) => {
        for (const keyOption of defaultKeyOptions) {
            if (keyOption.value === value) {
                var filterAuthOptions = defaultAuthOptions.filter(authOption =>  keyOption.rules.includes(authOption.value))
                authOptionsList[index] = filterAuthOptions;
                setAuthOptionsList([...authOptionsList]);
            }
        }
    }

    const addOptionsList = (except?: {authorization: "", key: ""}, index?: number) => {
        authOptionsList.push(defaultAuthOptions.filter(item => item.value !== "AllowStandardUserToSetSystemService"));
        keyOptionsList.push(defaultKeyOptions);
        setAuthOptionsList(authOptionsList);
        setKeyOptionsList(keyOptionsList);
        if (except && index) {
            authChange(except.authorization, index);
            keyChange(except.key, index);
        }
    }

    const getOptions = (key:any) =>{
        console.log(key);
        if(["Camera","Microphone"].includes(key))
        {
            return [
                    {label: "Deny", value: "Deny"}
                ]
        }
        else if(["ListenEvent","ScreenCapture"].includes(key))
        {
            return [
                    {label: "Deny", value: "Deny"},
                    {label: "AllowStandardUserToSetSystemService", value: "AllowStandardUserToSetSystemService"}
                ]
        }
        else
        {
            return [
                    {label: "Allow", value: "Allow"},
                    {label: "Deny", value: "Deny"}
                ]
        }
    }
    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("Privacy Preferences")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                     <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置隐私偏好的管控规则")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { setShowTable(2) }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <div className="tAr">
                            <Button type="primary" onClick={() => { 
                                setShowModal(true);
                                setPlaceholder(`${t("如")}: /Application/Apple Configurator2.app`);
                            }}
                            ><PlusOutlined />{t("添加隐私规则")}</Button>
                        </div>
                        <div style={{width: "100%"}}>
                            <Table 
                                dataSource={tableList} 
                                pagination={false}
                                rowKey={record => record.appId} 
                                style={{ width: "100%" ,marginLeft:8}}
                                locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                            >
                                <Table.Column 
                                    title={t("应用")} 
                                    key="identifier" 
                                    dataIndex="identifier"
                                    render={(_, row: any) => `${row?.identifierType === "path" ? t("应用路径") : t("应用包名")} ${row?.identifier}`}
                                ></Table.Column>
                                <Table.Column title={t("代码要求")} key="codeRequirement" dataIndex="codeRequirement"></Table.Column>
                                <Table.Column 
                                    title={t("静态验证")} 
                                    key="staticCode" 
                                    dataIndex="staticCode" 
                                    render={(value) => value ? t("是") : t("否")}
                                ></Table.Column>
                                <Table.Column 
                                    title={t("规则")} 
                                    key="ruleList" 
                                    dataIndex="ruleList"
                                    ellipsis
                                    render={(value) => {
                                        var tmp = value.map((item: any) => `${item.authorization} ${item.key}`);
                                        return tmp.join()
                                    }}
                                ></Table.Column>
                                <Table.Column
                                    title={t("操作")}
                                    key="id"
                                    dataIndex="id"
                                    render={(value, row) => {
                                        return (
                                            <>
                                                <Button type="link" onClick={() => { onEdit(row) }}>{t("编辑")}</Button>
                                                <Popconfirm 
                                                    title={`${t("确认删除")}?`} 
                                                    onConfirm={() => { deleteById(value) }}
                                                    okText={t("确认")}
                                                    cancelText={t("取消")}
                                                >
                                                    <Button type="text" danger>{t("删除")}</Button>
                                                </Popconfirm>
                                            </>
                                        )
                                    }}
                                ></Table.Column>
                            </Table>
                            <Pagination
                                style={{ textAlign: "right", marginTop: "20px" }}
                                pageSize={pageSize}
                                current={pageIndex}
                                total={totalCount}
                                showTotal={(total, range) => `${range[0]}-${range[1]} / ${total} ${t("条")}`}
                                onChange={(page, pageSize) => { getDataList(page, pageSize) }}
                                onShowSizeChange={(current, size) => { getDataList(current, size) }}
                            ></Pagination>
                        </div>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" loading={loading} onClick={() => { console.log("click log") }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteAll() }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
            <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={showModal}
                title={t("隐私规则")}
                onOk={() => { onOk() }}
                onCancel={() => {
                    setShowModal(false);
                    setId("");
                    dataForm.resetFields();
                    setPlaceholder(`${t("如")}: /Application/Apple Configurator2.app`);
                    setAuthOptionsList([]);
                    setKeyOptionsList([]);
                }}
                okText={t("确认")}
                cancelText={t("取消")}
                destroyOnClose
                width="650px"
            >
                <Form
                    style={{ width: "90%", marginTop: 36, marginLeft: 45 }}
                    layout="vertical"
                    form={dataForm}
                    labelCol={{ span: 24 }}
                    initialValues={{identifierType: "path", staticCode: false}}
                    autoComplete="on"
                >
                    <Form.Item label={t("应用")} name="identifier" rules={[{ required: true }]}>
                        <Input placeholder={placeholder} disabled={id ? true : false} addonBefore={
                            <Form.Item name="identifierType" noStyle>
                                <Select onChange={(value) => { placeholderChange(value) }} disabled={id ? true : false}>
                                    <Select.Option value="path">{t("应用路径")}</Select.Option>
                                    <Select.Option value="bundleID">{t("应用包名")}</Select.Option>
                                </Select>
                            </Form.Item>
                        }></Input>
                    </Form.Item>
                    <Form.Item label={t("代码要求")} name="codeRequirement" rules={[{ required: true }]}>
                        <Input></Input>
                    </Form.Item>
                    <Form.Item label={t("静态验证")} name="staticCode" rules={[{ required: true }]}>
                        <Select>
                            <Select.Option value={false}>{t("否")}</Select.Option>
                            <Select.Option value={true}>{t("是")}</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.List name="ruleList">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map((field, index) => {
                                    const ruleVal = dataForm.getFieldValue(['ruleList', field.name, 'key']);
                                    return (
                                        <Form.Item key={field.key} label={index === 0 ? t("规则") : ""}>
                                            <Row gutter={8} style={{height: 32}}>
                                                <Col span={16}>
                                                    <Form.Item noStyle
                                                        {...field}
                                                        name={[field.name, "key"]}
                                                        // fieldKey={[field.fieldKey]}
                                                    >
                                                        <Select options={keyOptionsList[index]} allowClear onChange={(value) => { keyChange(value, index) }}></Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item noStyle
                                                        {...field}
                                                        label="authorization"
                                                        name={[field.name, "authorization"]}
                                                        // fieldKey={[field.fieldKey]}
                                                    >
                                                        <Select options={getOptions(ruleVal)} allowClear onChange={(value) => { authChange(value, index) }}></Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col>
                                                    <Button type="dashed" onClick={() => { remove(field.name) }}>-</Button>
                                                </Col>
                                            </Row>
                                        </Form.Item>
                                    )
                                })}
                                <Form.Item>
                                    <Button type="dashed" onClick={() => { 
                                        add();  
                                        addOptionsList();
                                    }} block>
                                        <PlusOutlined />{t("规则")}
                                    </Button>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Form>
            </Modal>
        </div>
    </>);
    
}
